import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

/**
 * MainLayout 主布局组件
 * 
 * 布局结构：
 * - 上方：Header 组件
 * - 中间：main 区域（使用 Outlet 渲染子路由）
 * - 下方：Footer 组件
 * 
 * 使用方式：
 * 在路由配置中作为父路由，子路由通过 Outlet 渲染
 */
export default function MainLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      {/* 顶部 Header */}
      <Header />
      
      {/* 中间 Main 区域 - 使用 Outlet 渲染子路由 */}
      <main className="flex-1">
        <Outlet />
      </main>
      
      {/* 底部 Footer */}
      <Footer />
    </div>
  );
}

